import React from 'react';
import './MovingSubtitle.css';

function MovingSubtitle() {
  return (
    <div className="moving-subtitle">
      <div className="scroller">
          <span className="moving-text">
          * A Revolution of Beauty * A Revolution of Beauty * A Revolution of Beauty * A Revolution of Beauty * A Revolution of Beauty&nbsp;
          </span>
          <span className="moving-text">
          &nbsp;* A Revolution of Beauty * A Revolution of Beauty * A Revolution of Beauty * A Revolution of Beauty * A Revolution of Beauty *
          </span>
        </div>
    </div>
  );
}

export default MovingSubtitle;
